/**
 *  Get attributes for an HTML element, which Cloudflare can use to dynamically adjust the HTML response, dropping all segments which the user shouldn't see.
 * NOTE: done through Cloudflare (instead of React) to improve Core Web Vitals, especially CLS.
 * @param {object}  args
 * @param {string}  args.slug - slug of the experiment, should match CMS config
 * @param {number}  args.segment - segment that this element should be visible for (E.g. 0 to show on Control)
 * @param {Array | null}   args.experimentDefinitions - all experiment definitions from the CMS - optional to rely on getExperimentDefinition
 * @returns {object} Attributes to spread onto HTML element
 */

import { getExperimentDefinition } from '@ratehub/base-ui';


export default function getServerSideExperimentAttributes({ slug, segment, experimentDefinitions }) {
    return {
        ['data-experiment-name']: slug,
        ['data-experiment-segment']: segment,
        ['data-experiment-variations']: JSON.stringify(
            (experimentDefinitions
                ? (experimentDefinitions.find(exp => exp.slug === slug)?.variations)
                : getExperimentDefinition(slug)?.variations
            ) ?? [ 0 ] // [0] will cause it to fallback to only show control
        ),
    };
}
